import { Point } from 'pixi.js-legacy';
import { ScalingText } from './scalingText';
export class ScalableTextOptions {
    constructor() {
        this.text = '';
        this.x = 0;
        this.y = 0;
        this.font = 'Arial';
        this.anchor = new Point(0, 0);
        this.rotation = 0;
        this.fill = 0x000000;
        this.wordWrap = false;
        this.wordWrapWidth = 100;
        this.align = 'left';
        this.add = true;
        this.size = 18;
        this.onResize = () => { };
    }
}
export class ScalableTextManager {
    constructor() {
        this.allText = [];
    }
    static getInstance() {
        if (!this._instance) {
            this._instance = new ScalableTextManager();
        }
        return this._instance;
    }
    reset() {
        for (const st of this.allText) {
            for (const pt of st.texts) {
                pt.destroy();
            }
            st.destroy();
        }
        this.allText = [];
    }
    destroy() {
        ScalableTextManager._instance = undefined;
    }
    createText(parent, options = new ScalableTextOptions()) {
        const txt = new ScalingText(parent, options);
        this.allText.push(txt);
        const currentScale = txt.getCurrentScale(this.container.scale.x);
        if (options.add) {
            parent.addChild(currentScale);
        }
        return txt;
    }
    update() {
        for (const text of this.allText) {
            if (text.currentIndex < text.texts.length) {
                const pixiText = text.texts[text.currentIndex];
                if (pixiText) {
                    text.parent.removeChild(pixiText);
                    text.parent.addChild(text.getCurrentScale(this.container.scale.x));
                    text.resizeCallback(pixiText);
                }
            }
        }
    }
}
